import {CallOptions, MenuItem} from "../types/types";

export let API_URL: any;
export let REACT_STATISTIC_API_URL = process.env.REACT_STATISTIC_API_URL;
export let WSS_URL:any;
export let WEBRTC_WSS_URL : any;
export let WWS_WEBRTC:any;
export let Version: string = 'v.1.1.26.7';
export let MVP = true;
export let PROD = false;
export let STAGE = false;
export let DEV = false;
export const hostname = window.location.hostname;
const origin = window.location.origin;

function getSuffixFromOrigin(origin: string): string {
    const match = origin.match(/^cc(?:-(\w+))?\.stage(\.|$)/);
    return match && match[1] ? `-${match[1]}` : '';
}

if (hostname === 'callcenter.stage.in.ua') {
    API_URL = process.env.REACT_APP_PROD_API_URL;
    WSS_URL = process.env.REACT_APP_PROD_WSS_URL;
    WEBRTC_WSS_URL = process.env.REACT_APP_PROD_WWS_WEBRTC_URL;
    WWS_WEBRTC = process.env.REACT_APP_PROD_WWS_WEBRTC;
    REACT_STATISTIC_API_URL = process.env.REACT_STATISTIC_API_URL;
} else if (hostname === 'localhost' || hostname === 'callcenter-dev.stage.in.ua') {
    API_URL = process.env.REACT_APP_API_URL;
    WSS_URL = process.env.REACT_APP_WSS_URL;
    WEBRTC_WSS_URL = process.env.REACT_APP_WWS_WEBRTC_URL;
    WWS_WEBRTC = process.env.REACT_APP_WWS_WEBRTC;

    // API_URL = process.env.REACT_APP_PROD_API_URL;
    // WSS_URL = process.env.REACT_APP_PROD_WSS_URL;
    // WEBRTC_WSS_URL = process.env.REACT_APP_PROD_WWS_WEBRTC_URL;
    // WWS_WEBRTC = process.env.REACT_APP_PROD_WWS_WEBRTC;
    // REACT_STATISTIC_API_URL = process.env.REACT_STATISTIC_API_URL;
} else {
    API_URL = origin + '/api/';
    WSS_URL = origin + '/wss/';
    WWS_WEBRTC = hostname;
    let suffix = getSuffixFromOrigin(hostname);
    WEBRTC_WSS_URL = 'wss://webrtc' + suffix + '.stage.in.ua/';
}

switch (hostname) {
    case 'cc-dev.stage.in.ua':
        DEV = true;
        break;
    case 'cc-stage.stage.in.ua':
        STAGE = true;
        break;
    case 'cc.stage.in.ua':
        PROD = true;
        break;
    default:
        DEV = true;
}

export const menuConfig: MenuItem[] = [
    {
        label: 'Вихiднi кампанii',
        icon: 'pi pi-folder',
        to: '/',
        name: 'Campaigns'
    },
    {
        label: 'Вхідні черги',
        icon: 'pi pi-database',
        to: '/queue',
        name: 'Queues'
    },
    {
        label: 'Монiторинг Подiй',
        icon: 'pi pi-chart-bar',
        to: '/monitoring',
        name: 'Monitoring'
    },
    {
        label: 'Моніторинг Черг',
        icon: 'pi pi-chart-line',
        to: '/monitoring_queue',
        name: 'QueueMonitor'
    },
    {
        label: 'Branch',
        icon: 'pi pi-building',
        to: '/branch',
        name: 'Branch'
    },
    {
        label: 'Групи кваліфікацій',
        icon: 'pi pi-th-large',
        to: '/skill_group',
        name: 'SkillGroup'
    },
    {
        label: 'Статистика',
        icon: 'pi pi-chart-pie',
        name: 'Statistic',
        items: [
            {
                label: 'Дані дзвінків',
                icon: 'pi pi-chart-bar',
                to: '/statistics',
                name: 'Statistic'
            },
            {
                label: 'Дзвінки операторів',
                icon: 'pi pi-chart-line',
                to: '/calls',
                name: 'Statistic'
            },
            {
                label: 'Статуси операторів',
                icon: 'pi pi-verified',
                to: '/statuses',
                name: 'Statistic'
            },
            {
                label: 'Статуси оператора',
                icon: 'pi pi-share-alt',
                to: '/period_statuses',
                name: 'Statistic'
            },
            {
                label: 'Статистика транка',
                icon: 'pi pi-sliders-v',
                to: '/trunk_statistics',
                name: 'Statistic'
            },
            {
                label: 'Ліди кампанії',
                icon: 'pi pi-folder-open',
                to: '/leads',
                name: 'Campaigns'
            },
            {
                label: 'Контроль якості',
                icon: 'pi pi-check-square',
                to: '/quality_control',
                name: 'QualityControlStatistic'
            }
        ]
    },
    {
        label: 'Налаштування',
        icon: 'pi pi-cog',
        name: 'Settings',
        items: [
            {
                label: 'Ролі користувачів',
                icon: 'pi pi-shield',
                to: '/role',
                name: 'Role'
            },
            {
                label: 'Статуси',
                icon: 'pi pi-verified',
                to: '/status',
                name: 'Status'
            },
            {
                label: 'Користувачі',
                icon: 'pi pi-id-card',
                to: '/usersmanager',
                name: 'Users'
            },
            {
                label: 'Транки',
                icon: 'pi pi-sliders-v',
                to: '/trunks',
                name: 'Trunks'
            },
            {
                label: 'Аудіоконтроль',
                icon: 'pi pi-microphone',
                to: '/audio_control',
                name: 'QualityControl'
            },
            {
                label: 'IVR Конфігурації',
                icon: 'pi pi-sitemap',
                to: '/ivrconfiguration',
                name: 'IVRConfig'
            },
            {
                label: 'Бібліотека аудіо',
                icon: 'pi pi-volume-up',
                to: '/audio',
                name: 'Audio'
            }
        ]
    }
];

export const menuRoleConfig: MenuItem[] = [
    {
        label: 'Вихiднi кампанii',
        icon: 'pi pi-folder',
        to: '/',
        name: 'Campaigns'
    },
    {
        label: 'Вхідні черги',
        icon: 'pi pi-database',
        to: '/queue',
        name: 'Queues'
    },
    {
        label: 'Монiторинг Подiй',
        icon: 'pi pi-chart-bar',
        to: '/monitoring',
        name: 'Monitoring'
    },
    {
        label: 'Моніторинг Черг',
        icon: 'pi pi-chart-line',
        to: '/monitoring_queue',
        name: 'QueueMonitor'
    },
    {
        label: 'Branch',
        icon: 'pi pi-building',
        to: '/branch',
        name: 'Branch'
    },
    {
        label: 'Плеєр',
        icon: 'pi pi-play',
        to: '/role',
        name: 'Player'
    },
    {
        label: 'Групи кваліфікацій',
        icon: 'pi pi-th-large',
        to: '/skill_group',
        name: 'SkillGroup'
    },
    {
        label: 'Статистика',
        icon: 'pi pi-chart-pie',
        name: 'Statistic',
        items: [
            {
                label: 'Дані дзвінків',
                icon: 'pi pi-chart-bar',
                to: '/statistics',
                name: 'Statistic'
            },
            {
                label: 'Дзвінки операторів',
                icon: 'pi pi-chart-line',
                to: '/calls',
                name: 'Statistic'
            },
            {
                label: 'Статуси операторів',
                icon: 'pi pi-verified',
                to: '/statuses',
                name: 'Statistic'
            },
            {
                label: 'Статистика транка',
                icon: 'pi pi-sliders-v',
                to: '/trunk_statistics',
                name: 'Statistic'
            },
            {
                label: 'Ліди кампанії',
                icon: 'pi pi-folder-open',
                to: '/leads',
                name: 'Campaigns'
            }
        ]
    },
    {
        label: 'Контроль якості',
        icon: 'pi pi-check-square',
        to: '/quality_control',
        name: 'QualityControlStatistic'
    },
    {
        label: 'Налаштування',
        icon: 'pi pi-cog',
        name: 'Settings',
        items: [
            {
                label: 'Ролі користувачів',
                icon: 'pi pi-shield',
                to: '/role',
                name: 'Role'
            },
            {
                label: 'Статуси',
                icon: 'pi pi-verified',
                to: '/status',
                name: 'Status'
            },
            {
                label: 'Користувачі',
                icon: 'pi pi-id-card',
                to: '/usersmanager',
                name: 'Users'
            },
            {
                label: 'Транки',
                icon: 'pi pi-sliders-v',
                to: '/trunks',
                name: 'Trunks'
            },
            {
                label: 'Аудіоконтроль',
                icon: 'pi pi-microphone',
                to: '/audio_control',
                name: 'QualityControl'
            },
            {
                label: 'IVR Конфігурації',
                icon: 'pi pi pi-sitemap',
                to: '/ivrconfiguration',
                name: 'IVRConfig'
            },
            {
                label: 'Бібліотека аудіо',
                icon: 'pi pi-volume-up',
                to: '/audio',
                name: 'Audio'
            },
            {
                label: 'SpyCall',
                icon: 'pi pi-volume-up',
                to: '/audio',
                name: 'SpyCall'
            },
            {
                label: 'IVR Config',
                icon: 'pi pi-sitemap',
                name: 'IVRConfig'
            },
        ]
    }
];

export const callOptions: CallOptions = {
    mediaConstraints: {
        audio: {
            echoCancellation: false,
            autoGainControl: false,
            noiseSuppression: false,
            deviceId: {exact: ["default"]}
        },
        video: false
    },
    pcConfig: {
        iceCandidatePoolSize: 0,
        iceTransportPolicy: "relay",
        rtcpMuxPolicy: "require",
        iceServers: []
    },
    extraHeaders: []
}

export interface IceProbeMeta {
    userId?: string | number | null;
    userName?: string | null;
    version?: string | null;
    flowUuid?: string | null;
}

export const probeTurnServers = (
    iceServers: RTCIceServer[],
    meta: IceProbeMeta = {},
    timeoutMs = 5000
): Promise<{ ok: boolean; reason?: string }> => {
    const ref = {
        userId: meta.userId ?? "unknown",
        userName: meta.userName ?? "unknown",
        version: "CC " + (meta.version ?? "unknown"),
        ...(meta.flowUuid ? {flowUuid: meta.flowUuid} : {}),
    };

    return new Promise((resolve) => {
        if (!iceServers || iceServers.length === 0) {
            resolve({ok: false, reason: "no-ice-servers"});
            return;
        }

        let pc: RTCPeerConnection;
        try {
            pc = new RTCPeerConnection({iceTransportPolicy: "relay", iceServers});
        } catch (err) {
            // console.error("[ICE probe] failed to create RTCPeerConnection", ref, err);
            resolve({ok: false, reason: "pc-create-failed"});
            return;
        }

        let gotRelay = false;
        let settled = false;

        const finish = (ok: boolean, reason?: string) => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            try {
                pc.close();
            } catch {
            }
            resolve({ok, reason});
        };

        const timer = setTimeout(() => {
            // console.error("[ICE probe] timeout — no relay candidate received, TURN unreachable", ref, iceServers);
            finish(gotRelay, "timeout");
        }, timeoutMs);

        pc.onicecandidate = (e) => {
            if (!e.candidate) {
                if (gotRelay) {
                    // console.log("[ICE probe] OK — TURN responds, relay candidate received", ref, iceServers);
                } else {
                    // console.error("[ICE probe] gathering finished, 0 relay candidates — TURN returned no candidates", ref, iceServers);
                }
                finish(gotRelay, gotRelay ? undefined : "no-relay");
                return;
            }
            // console.log("[ICE probe] candidate", {
            //     ...ref,
            //     type: e.candidate.type,
            //     protocol: e.candidate.protocol,
            //     address: e.candidate.address,
            //     port: e.candidate.port,
            //     relatedAddress: e.candidate.relatedAddress,
            //     relatedPort: e.candidate.relatedPort,
            //     url: (e as any)?.url,
            //     candidate: e.candidate.candidate,
            // });
            if (e.candidate.type === "relay") {
                gotRelay = true;
            }
        };

        pc.onicecandidateerror = (err: any) => {
            // console.error("[ICE probe] candidate error", {
            //     ...ref,
            //     errorCode: err?.errorCode,
            //     errorText: err?.errorText,
            //     url: err?.url,
            //     address: err?.address,
            //     port: err?.port,
            // });
        };

        try {
            pc.createDataChannel("turn-probe");
            pc.createOffer()
                .then((offer) => pc.setLocalDescription(offer))
                .catch((err) => {
                    // console.error("[ICE probe] createOffer/setLocalDescription error", ref, err);
                    finish(false, "offer-failed");
                });
        } catch (err) {
            // console.error("[ICE probe] error starting ICE gathering", ref, err);
            finish(false, "start-failed");
        }
    });
};

export const base64ToBlob = (base64: string, contentType: string) => {
    const binaryString = window.atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], {type: contentType});
}

